<template>
    <div class="iso" :class="type" v-bind:style="position">
        <div class="inner">
            <span class="ani" :class="type"><slot name="ani"></slot></span>
            <span class="element" :class="type"><slot name="name"></slot></span>
            <img v-if="type === 'tshirt'" class="tshirt-print" width="60" height="41" src="/t-shirt-print.png"  />
            <img v-if="type === 'tivoli' || type === 'boder1' || type === 'boder2'" width="381" height="262" src="/iso-square-rough.svg" />
            <img v-else width="381" height="262" src="/iso-square.svg">
        </div>
    </div>
</template>

<script>
	import IsoBlock from "@/assets/univers/iso-square.svg"
	export default {
		name: "IsoItem",
        props: ["x","y","type"],
        components: {
			IsoBlock
        },
        computed: {
			position(){
				// 381x267
				let canvasWidth = 2000

                let baseWidth = (canvasWidth/2);
                let baseHeight = 30;

                let isoWidth = 470
                let isoHeight = 267

                let x = Number(this.x)
                let y = Number(this.y)

                return 'transform: translate('+ (baseWidth + ((x - y) * isoWidth / 2)) +'px,'+ (baseHeight + ((x + y) * isoHeight / 2))+'px)'
            }
        }
	}
</script>

<style lang="scss" scoped>
    .iso{
        position: absolute;
        top: 0px;
        left: 0px;
        margin-left: -190px;
        .inner{opacity: 0;}
        .tshirt-print{
            position: absolute;
            top: 82px;
            left: 160px;
            z-index: 1;
        }
        .element{
            position: absolute;
            top: 0;
            left: 0;
            &.velkommen{
                top: -38px;
                left: 50px;
            }
            &.information{
                top: -36px;
                left: 40px;
            }
            &.oeltelt{
	            top: -122px;
	            left: 0px;
            }
            &.tivoli{
	            top: -173px;
	            left: -14px;
            }
            &.tshirt{
                top: 17px;
                left: 18px;
            }
            &.royalunibrew{
                top: 58px;
                left: 98px;
            }
            &.dandomain{
                top: 40px;
                left: 128px;
            }
            &.guloggratis{
                top: 62px;
                left: 90px;
            }
            &.traeer{
                top: -83px;
                left: 36px;
            }
            &.horses{
                top: -25px;
                left: 90px;
            }
            &.lastbil{
	            top: -90px;
	            left: 8px;
            }
            &.billboard{
                top: -80px;
                left: 60px;
            }
            &.telte{
                top: 5px;
                left: 25px;
            }
            &.boder1{
                top: -43px;
                left: 16px;
            }
            &.boder2{
                top: -38px;
                left: 125px;
            }
            &.esport{
	            top: -80px;
	            left: -12px;
            }
	        &.donation{
		        top: -72px;
		        left: 9px;
	        }
        }
        .ani{
            position: absolute;
            &.esport{
                top: -80px;
                left: -12px;
            }
            &.lastbil{
                top: -90px;
                left: 8px;
            }
            &.donation{
                top: -72px;
                left: 9px;
            }
            &.oeltelt{
                top: -122px;
                left: 0px;
            }
            &.tivoli{
                top: -173px;
                left: -14px;
            }
            &.information{
                top: -27px;
                left: 198px;
            }
        }
        .coords{
            display: none;
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            text-align: center;
            padding-top: 30px;
        }
    }
</style>
